import {useAsync} from "react-async-hook";
import {$axios} from "../http/axiosInstance";

export const StoresService = {
    GetStores() {
        return useAsync(async () => {
            return await $axios.get('/stores/');
        }, [])
    }
}